var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.quarterInfo.longImage)?_c('div',{staticClass:"data-wrapper"},[_c('p',{staticClass:"wrapper-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"easy-image-block",on:{"click":_setup.previewCover}},[_c('div',{staticClass:"easy-image-title"},[_vm._v(_vm._s(_vm.quarterInfo.announcementTitle))]),_c('div',{staticClass:"easy-image-cover",style:({
				backgroundImage: `url(${_vm.quarterInfo.longImage})`
			})})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }